import * as Dialog from "../framework/dialog";
import { getUITranslation } from "../utils/get_ui_translation";
import { fetchJSON } from "../framework/api";

const ID_START_DATE_INPUT = "js-start-date-abandon";
const ID_END_DATE_INPUT = "js-end-date-abandon";
const ID_SECTION_ALL_SUBSESSIONS = "js-section-all-subsessions";
const ID_SELECT_TYPE_ABANDON = "js-select-type-abandon";
const ID_IS_BACK_CHECKBOXE = "js-is-back-checkbox";
const ID_SECTION_DE_REPORT = "js-section-de-report";
const ID_SELECT_DE_REPORT_REASON = "js-select-de-report-reason";
const ID_SECTION_DE_REPORT_DROPOUT_REASON = "js-section-de-report-dropout-reason";
const ID_SELECT_DE_REPORT_DROPOUT_REASON = "js-select-de-report-dropout-reason";
const ID_SECTION_DE_REPORT_NEW_JOB_START_DATE = "js-section-de-report-new-job-start-date";
const ID_SECTION_DE_REPORT_COMMENT = "js-section-de-report-comment";

//PREFIX_SECTION_CHECKBOXES Used to hidden all the subsession container
//PREFIX_SECTION_CHECKBOXES Used to hidden checkboxes container

// All logic should be base on it !
const PREFIX_SECTION_CHECKBOXES = "js-section-checkbox-";
const PREFIX_SECTION_SUBSESSION = "js-section-subsession-";

const checkbox = document.getElementById(ID_IS_BACK_CHECKBOXE);

document.querySelectorAll(".js-select-all-slots").forEach((button) => {
  button.addEventListener("change", (e) => select_all_slots_for_subsession_event(e));
});

document.getElementById(ID_START_DATE_INPUT)?.addEventListener("change", () => {
  filter_checkboxes();
});
document.getElementById(ID_END_DATE_INPUT)?.addEventListener("change", () => {
  filter_checkboxes();
});

document.getElementById(ID_SELECT_TYPE_ABANDON)?.addEventListener("change", (e) => {
  change_type_abandon(e);
});

document.getElementById(ID_SELECT_DE_REPORT_REASON)?.addEventListener("change", (e) => {
  change_de_report_reason(e);
});

document.getElementById(ID_SELECT_DE_REPORT_DROPOUT_REASON)?.addEventListener("change", (e) => {
  change_de_report_dropout_reason(e);
});

let isBackCheckboxState = checkbox?.value;

checkbox?.addEventListener("change", function (event) {
  isBackCheckboxState = event.target.checked;
});

function change_type_abandon(e) {
  const label = checkbox.closest("label");
  const section_de_report = document.getElementById(ID_SECTION_DE_REPORT);

  if (e.target.value === "abandon") {
    checkbox.checked = false;
    checkbox.disabled = true;
    label.setAttribute("aria-disabled", true);
    if (section_de_report) section_de_report.hidden = false;

    const section_all_subsessions = document.getElementById(ID_SECTION_ALL_SUBSESSIONS);

    section_all_subsessions.querySelectorAll("details:not([hidden]").forEach(function (detail) {
      detail.querySelectorAll(".checkbox.js-select-all-slots").forEach(function (c) {
        const subsession_id = c.getAttribute("data-subsession-id");
        select_all_slots_for_subsession_id(subsession_id);
      });
    });
  } else {
    checkbox.disabled = false;
    label.setAttribute("aria-disabled", false);
    checkbox.checked = isBackCheckboxState;
    if (section_de_report) section_de_report.hidden = true;
  }
}

function change_de_report_reason(e) {
  const section_dropout_reason = document.getElementById(ID_SECTION_DE_REPORT_DROPOUT_REASON);
  section_dropout_reason.hidden = e.target.value !== "dropped_out";
  refresh_de_report_dropout_details();
}

function change_de_report_dropout_reason(_e) {
  refresh_de_report_dropout_details();
}

// The new-job start date and the comment back a "new_job" / "other" dropout reason, which itself
// only exists for a dropout. They have to follow both selects: hiding them on the dropout reason
// alone would leave them on screen, detailing a reason that is no longer displayed, once the cause
// moves away from "dropped_out".
function refresh_de_report_dropout_details() {
  const reason = document.getElementById(ID_SELECT_DE_REPORT_REASON);
  const dropout_reason = document.getElementById(ID_SELECT_DE_REPORT_DROPOUT_REASON);
  const section_new_job_start_date = document.getElementById(ID_SECTION_DE_REPORT_NEW_JOB_START_DATE);
  const section_comment = document.getElementById(ID_SECTION_DE_REPORT_COMMENT);
  const dropped_out = reason.value === "dropped_out";

  section_new_job_start_date.hidden = !dropped_out || dropout_reason.value !== "new_job";
  section_comment.hidden = !dropped_out || dropout_reason.value !== "other";
}

function is_between_date(startDate, endDate, currentDate) {
  if (!startDate && !endDate) {
    return true;
  }
  if (!startDate && endDate) {
    return new Date(currentDate) <= new Date(endDate);
  }
  if (startDate && !endDate) {
    return new Date(currentDate) >= new Date(startDate);
  }

  if (startDate && endDate) {
    currentDate = new Date(currentDate);
    startDate = new Date(startDate);
    endDate = new Date(endDate);
    return (currentDate >= startDate) & (currentDate <= endDate);
  }
}

function filter_checkboxes() {
  const startDate = document.getElementById(ID_START_DATE_INPUT).value;
  const endDate = document.getElementById(ID_END_DATE_INPUT).value;
  const section_all_subsessions = document.getElementById(ID_SECTION_ALL_SUBSESSIONS);

  section_all_subsessions.querySelectorAll('input[type="checkbox"]:not(:checked)').forEach(function (c) {
    const dateSlot = c.getAttribute("data-date-slot");
    const slotId = c.getAttribute("data-ts-slot-id");

    if (slotId) {
      if (is_between_date(startDate, endDate, dateSlot)) {
        document.getElementById(PREFIX_SECTION_CHECKBOXES + slotId).hidden = false;
      } else {
        document.getElementById(PREFIX_SECTION_CHECKBOXES + slotId).hidden = true;
      }
    }
  });

  // After display or not each date and checkboxes
  // we should check for each subsession
  // if there is any date to display,
  // if not we hidden subsession section
  document.querySelectorAll("details").forEach(function (detail_subsession) {
    if (detail_subsession.querySelectorAll(".js-section-checkbox:not([hidden])").length > 0) {
      detail_subsession.hidden = false;
    } else {
      detail_subsession.hidden = true;
    }
  });
}

function select_all_slots_for_subsession_id(subsessionId) {
  const sectionSubsession = document.getElementById(PREFIX_SECTION_SUBSESSION + subsessionId);
  select_all_slots_for_subsession_logic(true, sectionSubsession);
}

function select_all_slots_for_subsession_event(event) {
  const is_checked = event.target.checked;
  const subsessionId = event.target.getAttribute("data-subsession-id");
  const sectionSubsession = document.getElementById(PREFIX_SECTION_SUBSESSION + subsessionId);
  select_all_slots_for_subsession_logic(is_checked, sectionSubsession);
}
function select_all_slots_for_subsession_logic(is_checked, sectionSubsession) {
  sectionSubsession.querySelectorAll('input[type="checkbox"]').forEach(function (c) {
    const slotId = c.getAttribute("data-ts-slot-id");
    // hidden information is on checkboxes container
    if (slotId && !document.getElementById(PREFIX_SECTION_CHECKBOXES + slotId).hidden) {
      c.checked = is_checked;
    }
  });
}

// popup display abandon
async function delete_abandon(ts_id, abandon_id, is_abandon) {
  const delete_button = document.getElementById(`delete_abandon_button_${abandon_id}`);
  const text_delete_abandon = JSON.parse(window.abandon_table_locales)["delete_abandon"];
  const text_delete_absence = JSON.parse(window.abandon_table_locales)["delete_absence"];
  const text = is_abandon == "true" ? text_delete_abandon : text_delete_absence;
  const okayed = await Dialog.okCancel(text, "");

  if (okayed) {
    const urlDeleteAbandon = p`/training_sessions/${ts_id}/delete_json/${abandon_id}`;
    ajax({
      url: urlDeleteAbandon,
      method: "delete",
      beforeSend: () => (delete_button.disabled = true),
      complete: () => (delete_button.disabled = false),
      error: (e) => console.error(e.responseText),
      success: function (data) {
        if (data.success) {
          window.location.href = p`/training_sessions/${ts_id}/abandons`;
        }
      },
    });
  }
}

async function delete_partial_absence(ts_id, partial_absence_id, tts_id) {
  const delete_button = document.getElementById(`delete_partial_absence_button_${partial_absence_id}`);
  const okayed = await Dialog.okCancel(getUITranslation("Confirmer la suppression du retard ?"), "");

  if (okayed) {
    delete_button.disabled = true;
    try {
      const data = await fetchJSON(p`/ajax/training_sessions/${ts_id}/partial_absences/${partial_absence_id}`, { method: "DELETE" });
      if (data.success) {
        window.location.href = p`/training_sessions/${ts_id}/abandons/tts/${tts_id}`;
      }
    } catch (e) {
      console.error(e);
    } finally {
      delete_button.disabled = false;
    }
  }
}
window.delete_partial_absence = delete_partial_absence;
window.delete_abandon = delete_abandon;
